import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { take } from 'rxjs';
import { sha256 } from 'js-sha256';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public show: boolean = false;
  public loading: boolean = false;
  public loginForm!: FormGroup;
  public logInError: any = false;

  constructor(
    private _formBLogin: FormBuilder,
    private _authService: AuthService,
    public router: Router,
    ) {
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.loginForm = this._formBLogin.group({
      email: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(50)])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(25)])]
    });
  }
  showPassword() {
    this.show = !this.show;
  }

  get sessionExpired(): boolean {
    return this._authService.sessionExpired;
  }


  // Simple Login
  login() {
    if(this.loginForm.valid){
      this.loading = true;
      const data = {
        email : this.loginForm.controls['email'].value,
        password : sha256(this.loginForm.controls['password'].value)
      }
      this._authService.login(data).pipe(take(1)).subscribe({
        next:(res) => {
          if(res){
            this._authService.setUser(res);
            this.logInError = false;
            this.router.navigate(['/admin/Nuevo-cliente']);
            this.loading = false;
          }else{
            this.loading = false;
            this.logInError = true;
          }
        },
        error:(err)=> {
          this.logInError = true;
          this.loading = false;
          console.log(err)
          return
        }
      })
    }
  }
}
